import styled from 'styled-components';

import { Centered } from '@sorare/core/src/atoms/layout/Centered';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const BaseLayout = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr calc(16 * var(--unit));
  grid-template-areas: 'top' 'center' 'bottom';
  align-items: center;
  justify-items: center;
  overflow: hidden;
  gap: var(--double-unit);
  user-select: none;
  background-image:
    linear-gradient(to bottom, var(--c-nl-200) 20%, transparent 30%),
    linear-gradient(to top, var(--c-nl-200) 5%, transparent 20%);
  @media ${laptopAndAbove} {
    min-height: 660px;
    max-height: none;
  }
`;

export const TopArea = styled(Centered)`
  grid-area: top;
  align-items: flex-start;
  width: 100%;
`;

export const BottomArea = styled.div`
  grid-area: bottom;
  margin-top: auto;
  padding: var(--double-unit);
  &.hidden {
    visibility: hidden;
  }
`;

export const CenterArea = styled(Horizontal).attrs({ center: true })`
  --margin-bottom-center-area: calc(5 * var(--unit));
  grid-area: center;
  --stripe-height: 32px;
  --card-width: 190px;
  position: relative;
  min-height: 0;
  min-width: 0;
  height: 100%;
  display: grid;
  place-items: center;
  place-content: center;
`;

export const CardWrapper = styled.div`
  height: 100%;
  width: 100%;
  max-width: var(--card-width);
  aspect-ratio: var(--card-aspect-ratio);
`;
